import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { AppService } from '../core/services/app.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { toggleAnimation, AppDateFormatPipe } from '@sukna/shared';
import { NgClass, NgComponentOutlet, NgIf, AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Observable } from 'rxjs';
import { IconMenuComponent } from '@sukna/shared';
import { IconSearchComponent } from '@sukna/shared';
import { IconSunComponent } from '@sukna/shared';
import { IconMoonComponent } from '@sukna/shared';
import { IconLaptopComponent } from '@sukna/shared';
import { MenuModule } from 'headlessui-angular'; 
import { IconLogoutComponent } from '@sukna/shared';
import { IconCaretDownComponent } from '@sukna/shared';
import { navMenuList } from '../shared/constants';
import { HasPermissionDirective } from '@sukna/shared';
import { AuthService } from '../core/services/api/auth.service';
import { isRtlLanguage } from '@sukna/shared';

@Component({
    selector: 'header',
    templateUrl: './header.html',
    animations: [toggleAnimation],
    imports: [
        NgClass,
        NgComponentOutlet,
        NgIf,
        NgTemplateOutlet,
        TranslatePipe,
        MenuModule,
        RouterModule,
        IconMenuComponent,
        IconSearchComponent,
        IconLaptopComponent,
        IconSunComponent,
        IconMoonComponent,

        IconLogoutComponent,
        IconCaretDownComponent,
        HasPermissionDirective,
        AsyncPipe,
        AppDateFormatPipe,
    ],
})
export class HeaderComponent implements OnInit {

    @Input() onboardingTitleKey = '';
    @Input() onboardingTitle = '';
    @Input() onboardingStartDate = '';
    @Input() onboardingApplicationStatusName: string | null = null;
    @Input() onboardingIsViewOnly = false;
    @Input() onboardingShowBack = false;
    @Output() onboardingBackClick = new EventEmitter<void>();

    isRtlLanguage = isRtlLanguage;

    store: any;
    search = false;
    navMenuList = navMenuList;
    user$: Observable<any>;
    showFundsDropdown = false;
    showMobileMenu = false;
    showMobileFunds = false;
    isOnboardingRoute = false;
    isAuthRoute = false;

    constructor(
        private _authService: AuthService,
        public translate: TranslateService,
        public storeData: Store<any>,
        public router: Router,
        private appSetting: AppService,
    ) {
        this.initStore();
        this.user$ = this.storeData.select((state: any) => state.auth?.user);
 
    }
    async initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    ngOnInit() {
        this.setActiveDropdown();
        this.checkOnboardingRoute();
        this.checkAuthRoute();
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.setActiveDropdown();
                this.checkOnboardingRoute();
                this.checkAuthRoute();
            }
        });
    }

    setActiveDropdown() {
        const selector = document.querySelector('ul.horizontal-menu a[routerLink="' + window.location.pathname + '"]');
        if (selector) {
            selector.classList.add('active');
            const all: any = document.querySelectorAll('ul.horizontal-menu .nav-link.active');
            for (let i = 0; i < all.length; i++) {
                all[0]?.classList.remove('active');
            }
            const ul: any = selector.closest('ul.sub-menu');
            if (ul) {
                let ele: any = ul.closest('li.menu').querySelectorAll('.nav-link');
                if (ele) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele?.classList.add('active');
                    });
                }
            }
        }
    }

    checkOnboardingRoute() {
        this.isOnboardingRoute = this.router.url.startsWith('/onboarding');
    }

    checkAuthRoute() {
        const path = this.router.url.split('?')[0];
        const authPrefixes = ['/login', '/register', '/forgot-password', '/mfa', '/reset-password', '/verify-email'];
        this.isAuthRoute = authPrefixes.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
    }

    changeLanguage(item: any) {
        this.translate.use(item.code);
        this.appSetting.toggleLanguage(item);
        if (isRtlLanguage(this.store.locale?.toLowerCase())) {
            this.storeData.dispatch({ type: 'toggleRTL', payload: 'rtl' });
        } else {
            this.storeData.dispatch({ type: 'toggleRTL', payload: 'ltr' });
        }
        window.location.reload();
    }

    toggleTheme(theme: string) {
        this.storeData.dispatch({ type: 'toggleTheme', payload: theme });
    }

    logout() {
        this._authService.logout()
    }
}
